import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import React, { useEffect, useState } from "react";
import CardExibirPdf from "../../../components/CardExibirPDF";
import CardSeplag from "../../../components/CardSeplag";
import {
  carregarArvoreRag,
  carregarArvoreRagComFiltro,
  carregarArvoreRagPermissao,
  gerarRelatorioPermissao,
} from "../../../service/Rag/ArvoreRag";

import download from "downloadjs";
import { useSelector } from "react-redux";
import { printToast } from "../../../config/global";

const RelatorioPermissaoRag = () => {
  const user = useSelector((state) => state.userReducer.user);

  const TipoRelatorio = [
    { name: "PDF", code: "P" },
    { name: "EXCEL", code: "E" },
  ];

  const [cDadosArvorePrograma, setCDadosArvorePrograma] = useState([]);
  const [cDadosArvore, setCDadosArvore] = useState([]);
  const [cDadosExercicios, setCDadosExercicios] = useState([]);
  const [cDadosUOs, setCDadosUOs] = useState([]);
  const [cDadosOrgaos, setCDadosOrgaos] = useState([]);
  const [orgaoSelecionado, setOrgaoSelecionado] = useState([]);
  const [cDadosProgramas, setCDadosProgramas] = useState([]);
  const [cDadosAcoes, setCDadosAcoes] = useState([]);
  const [exercicioSelecionado, setExercicioSelecionado] = useState(null);
  const [uoSelecionada, setUoSelecionada] = useState(null);
  const [programaSelecionado, setProgramaSelecionado] = useState(null);
  const [acaoSelecionada, setAcaoSelecionada] = useState(null);
  const [tipoRelatorioSelecionado, setTipoRelatorioSelecionado] = useState({ name: "PDF", code: "P" });
  const [tituloPDF, setTituloPDF] = useState("");
  const [dadosRelatorioBase64, setDadosRelatorioBase64] = useState(null);
  const [isExibirPDF, setIsExibirPDF] = useState(false);
  const [exibirRelatorio, setExibirRelatorio] = useState(false);
  const [isMONRL_ADMIN_CENTRAL] = useState(buscarPerfil("MONRL_ADMIN_CENTRAL"));
  const [isMONRL_ANALISTA] = useState(buscarPerfil("MONRL_ANALISTA"));
  const [isMONRL_ACESSO_ORGAO_CONTROLE] = useState(buscarPerfil("MONRL_ACESSO_ORGAO_CONTROLE"));

  function buscarPerfil(pNomeRole) {
    let retorno = false;
    if (user) {
      user.contaAcesso.authorities.forEach((perfilUser) => {
        if (perfilUser.nomeRole === pNomeRole) {
          retorno = true;
        }
      });
    } else {
      retorno = false;
    }

    return retorno;
  }

  let defaultArvoreRag = {
    arvorePtaMonitoras: cDadosArvore,
    listaExercicios: cDadosExercicios,
    orgaoFiplans: cDadosOrgaos,
    unidadeOrcamentarias: cDadosUOs,
    acao: cDadosAcoes,
    listaAcoes: cDadosAcoes,
  };
  function montarArvore(dadosArvore) {
    if (dadosArvore != null && dadosArvore.arvorePtaMonitoras != null) {
      // setCDadosArvore(dadosArvore.arvorePtaMonitoras);
    } else {
      setCDadosArvore({ content: { key: null, statusItem: null, tipoItem: null } });
    }

    setCDadosExercicios(dadosArvore != null ? dadosArvore.listaExercicios : null);
    setCDadosOrgaos(dadosArvore != null ? dadosArvore.orgaoFiplans : null);
    setCDadosUOs(dadosArvore != null ? dadosArvore.unidadeOrcamentarias : null);
  }
  const onChangeExercicio = async (e) => {
    let buscarArvoreGeral = isMONRL_ACESSO_ORGAO_CONTROLE || isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA;
    setExercicioSelecionado(e.value);
    setOrgaoSelecionado(null);
    setUoSelecionada(null);
    setCDadosOrgaos(null);
    setCDadosUOs(null);
    setCDadosProgramas(null);
    setCDadosAcoes(null);
    if (e.value !== undefined) {
      montarArvore(null);
      await carregarArvoreRagComFiltro(
        {
          idenExercicio: e.value.idenExercicio,
          idenOrgao: null,
          idenUo: null,
          idenPrograma: null,
        },
        defaultArvoreRag,
        buscarArvoreGeral
      ).then((res) => {
        montarArvore(res);
      });
    }
  };

  const onChangeOrgao = async (e) => {
    let buscarArvoreGeral = isMONRL_ACESSO_ORGAO_CONTROLE || isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA;

    if (e.value !== undefined) {
      setOrgaoSelecionado(e.value);

      await carregarArvoreRagComFiltro(
        {
          idenExercicio: exercicioSelecionado.idenExercicio,
          idenOrgao: e.value.idenOrgao,
          idenUo: null,
          idenPrograma: null,
        },
        defaultArvoreRag,
        buscarArvoreGeral
      ).then((dadosArvore) => {
        setCDadosUOs(dadosArvore != null ? dadosArvore.unidadeOrcamentarias : null);
      });
    } else {
      setOrgaoSelecionado(null);
      setUoSelecionada(null);
      setProgramaSelecionado(null);
      setAcaoSelecionada(null);

      setCDadosUOs(null);
      setCDadosProgramas(null);
      setCDadosAcoes(null);
    }
  };

  const capitalizeFirstLetter = (string) => {
    const lowerCase = string.toLowerCase();
    return lowerCase.charAt(0).toUpperCase() + lowerCase.slice(1);
  };

  const onChangeUo = async (e) => {
    let buscarArvoreGeral = isMONRL_ACESSO_ORGAO_CONTROLE || isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA;
    setUoSelecionada(e.value);

    if (e.value !== undefined) {
      await carregarArvoreRagComFiltro(
        {
          idenExercicio: exercicioSelecionado.idenExercicio,
          idenOrgao: orgaoSelecionado.idenOrgao,
          idenUo: e.value.idenUo,
          idenPrograma: null,
        },
        defaultArvoreRag,
        buscarArvoreGeral
      ).then((res) => {
        if (res != null && res.arvorePtaMonitoras != null) {
          if (res.arvorePtaMonitoras?.content) {
            setCDadosArvorePrograma(res.arvorePtaMonitoras.content);
            const programas = [];
            res.arvorePtaMonitoras.content.map((programa) => {
              programas.push(programa.programa);
            });
            setCDadosProgramas(programas);
          }
        }
      });
    } else {
      setCDadosProgramas(null);
      setProgramaSelecionado(null);

      setCDadosAcoes(null);
      setAcaoSelecionada(null);
    }
  };
  const onChangePrograma = (e) => {
    setProgramaSelecionado(e.value);

    if (e.value !== undefined) {
      const programaFilter = cDadosArvorePrograma.filter((programa) => {
        return programa.idenChaveItem === e.value.idenPrograma;
      });
      const acao = [];
      programaFilter.forEach((programa) => {
        programa?.children.forEach((child) => {
          acao.push({
            ...child,
            descricaoFiplan: `${child.codFiplanItem} - ${capitalizeFirstLetter(child.descricaoItem)}`,
          });
        });
      });
      setCDadosAcoes(acao);
    } else {
      setProgramaSelecionado(null);
      setCDadosAcoes(null);
    }
  };

  const onChangeAcao = (e) => {
    if (e.value !== undefined) {
      setAcaoSelecionada(e.value);
    } else {
      setAcaoSelecionada(null);
    }
  };

  const gerarRelatorio = () => {
    if (exercicioSelecionado == null) {
      return printToast({ severity: "error", summary: "Error", detail: "Exercicio obrigatório" });
    }
    if (orgaoSelecionado == null || uoSelecionada === null) {
      if (!(isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA || isMONRL_ACESSO_ORGAO_CONTROLE)) {
        return printToast({
          severity: "error",
          summary: "Error",
          detail: "Exercicio, Orgão e Unidade Orçamentaria obrigatório!",
        });
      }
    }

    let JsonBody = {
      idenExercicio: exercicioSelecionado && exercicioSelecionado != null ? exercicioSelecionado.idenExercicio : 0,
      idenOrgao: orgaoSelecionado && orgaoSelecionado !== null ? orgaoSelecionado.idenOrgao : null,
      idenUo: uoSelecionada && uoSelecionada != null ? uoSelecionada.idenUo : null,
      idenPrograma: programaSelecionado !== null ? programaSelecionado.idenPrograma : null,
      idenAcao: acaoSelecionada && acaoSelecionada != null ? acaoSelecionada.codFiplanItem : null,
      tipoRelatorio:
        tipoRelatorioSelecionado && tipoRelatorioSelecionado != null ? tipoRelatorioSelecionado.code : null,
    };

    gerarRelatorioPermissao(JsonBody).then((res) => {
      if (tipoRelatorioSelecionado.code === "E") {
        download(
          `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.data.dadosRelatorioBase64}`,
          `${res.data.nomeArquivo}`,
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      } else {
        let valorMb = res.data.dadosRelatorioBase64.length / 1024000;
        if (valorMb > 2) {
          download(
            `data:application/pdf;base64,${res.data.dadosRelatorioBase64}`,
            `${res.data.nomeArquivo}`,
            "application/pdf"
          );
        } else {
          setTituloPDF(res.data.nomeArquivo);
          setDadosRelatorioBase64(res.data.dadosRelatorioBase64);
          setIsExibirPDF(true);
        }
      }
    });
  };

  function fecharJanela() {
    setExibirRelatorio(false);
    setIsExibirPDF(false);
  }

  function abreJanela() {
    setExibirRelatorio(true);
  }
  useEffect(() => {
    if (user) {
      if (isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA || isMONRL_ACESSO_ORGAO_CONTROLE) {
        carregarArvoreRag().then((resAdm) => {
          montarArvore(resAdm);
        });
      } else {
        carregarArvoreRagPermissao().then((resPermissao) => {
          montarArvore(resPermissao);
        });
      }
    }
  }, []);

  return (
    <CardSeplag title="RELATÓRIO DE PERMISSÕES">
      <div className="p-fluid grid line-height-6">
        <div className="field col-12 md:col-12 ">
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-4 ">
              <label htmlFor="selExercicio">Exercício</label>
              <Dropdown
                emptyMessage="Dados não encontrados"
                emptyFilterMessage="Opção não encontrada"
                id="selExercicio"
                value={exercicioSelecionado}
                options={cDadosExercicios}
                onChange={onChangeExercicio}
                optionLabel="ano"
                filter
                filterBy="ano"
                placeholder="Selecione um exercício"
              />
            </div>
            <div className="field col-12 md:col-4">
              <label htmlFor="selOrgao">Órgão</label>
              <Dropdown
                emptyMessage="Dados não encontrados"
                emptyFilterMessage="Opção não encontrada"
                id="selOrgao"
                value={orgaoSelecionado}
                options={cDadosOrgaos}
                onChange={onChangeOrgao}
                optionLabel="descricaoFiplan"
                filter
                showClear
                filterBy="descricaoFiplan"
                placeholder="Selecione um Órgão"
              />
            </div>
            <div className="field col-12 md:col-4">
              <label htmlFor="selUo">Unidade Orçamentária</label>
              <Dropdown
                emptyMessage="Dados não encontrados"
                emptyFilterMessage="Opção não encontrada"
                value={uoSelecionada}
                options={cDadosUOs}
                onChange={onChangeUo}
                optionLabel="descricaoFiplan"
                filter
                showClear
                filterBy="descricaoFiplan"
                placeholder="Selecione uma U.O."
                display="chip"
              />
            </div>
          </div>
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-4 ">
              <label htmlFor="selPro">Programas</label>
              <Dropdown
                emptyMessage="Dados não encontrados"
                emptyFilterMessage="Opção não encontrada"
                id="selPro"
                value={programaSelecionado}
                options={cDadosProgramas}
                onChange={onChangePrograma}
                key="key"
                optionLabel="descricaoFiplan"
                filter
                showClear
                filterBy="descricaoFiplan"
                placeholder="Selecione um Programa"
                display="chip"
              />
            </div>
            <div className="field col-12 md:col-4">
              <label htmlFor="selAcoes">Ações</label>
              <Dropdown
                emptyMessage="Dados não encontrados"
                emptyFilterMessage="Opção não encontrada"
                id="selAcoes"
                value={acaoSelecionada}
                options={cDadosAcoes}
                onChange={onChangeAcao}
                key="idenPtaFiplan"
                optionLabel="descricaoFiplan"
                filterBy="descricaoFiplan"
                placeholder="Selecione uma Ação"
                showClear
                display="chip"
              />
            </div>
            <div className="field col-12 md:col-4">
              <label htmlFor="selTipo">Tipo de Impressão do Relatório</label>
              <Dropdown
                id="selTipo"
                value={tipoRelatorioSelecionado}
                options={TipoRelatorio}
                onChange={(e) => {
                  setTipoRelatorioSelecionado(e.value);
                }}
                optionLabel="name"
                placeholder="Selecione um Tipo de Impressão de Relatório"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 md:col-2">
        <Button type="button" label="Gerar" icon="pi pi-file-pdf" className="col-3 col-12" onClick={gerarRelatorio} />
        {isExibirPDF && (
          <CardExibirPdf
            tamanhoTela="'85.vw'"
            alturaTela="'350.vh'"
            stringPDF={"data:application/pdf;base64," + dadosRelatorioBase64}
            tituloTela={tituloPDF}
            isExibirPDF={isExibirPDF}
            position="center"
            onHide={fecharJanela}
          />
        )}
      </div>
    </CardSeplag>
  );
};
export default RelatorioPermissaoRag;
